export default __webpack_public_path__ + "static/groups-project-settings-light-mode-244dcecfc290032af139db6a2b79b514.png";